export default "__VITE_ASSET__CVic_8y1__"